import { styled } from "@mui/system";
import React from "react";
import { FlexRow } from "../../atoms/Flex/index";
import { Typography } from "@mui/material";

const Wrapper = styled(FlexRow)`
  max-height: 60px;
  padding: 10px 0;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
`;

const Image = styled("img")`
  height: 21px;
`;

export const SidebarHeader = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <>
      <Wrapper justify={isOpen ? "flex-start" : "center"} align={"center"}>
        {!isOpen && (
          <img
            src="/holding-hands.png"
            alt="logo"
            width={80}
            height={80}
            style={{ marginLeft: isOpen ? 8 : 0 }}
          />
        )}
        {isOpen && (
          <Typography variant="h6" style={{ marginLeft: 8 }}>
            Holding Hands
          </Typography>
        )}
      </Wrapper>
    </>
  );
};
